import { FC } from "react";

import { bookingGiftCard } from "../../../types/giftCard";

interface GiftCardProps {
  giftCard: bookingGiftCard;
}

const GiftCard: FC<GiftCardProps> = ({ giftCard }) => {
  return (
    <div className="space-y-2  p-2 border-[1px] border-[#EEF0FF] border-solid rounded border-x-0 border-t-0 my-1">
      <div className="space-y-2  p-2 ">
        <p className="text-color-primary">كارت هدايا</p>
        <div className="flex gap-1 justify-between"></div>
        <div className="flex flex-wrap justify-between gap-2">
          <p>
            <span className="text-color-sec-title mx-1">الى :</span>
            <span className="text-color-sec-title">
              {giftCard?.last_name
                ? giftCard?.first_name + " " + giftCard?.last_name
                : giftCard?.email}
            </span>
          </p>
          <p>
            <span className="text-color-primary font-semibold">
              {giftCard.giftCardValue}{" "}
              <small className="text-xs font-normal">ريال</small>
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default GiftCard;
